import React from 'react';
import { Link } from "react-router-dom";

import { EmptyContent } from "../../../../components";
import AppItem from "./AppItem";

import styles from "./ApplicationsSection.module.scss";

export const ApplicationsSection = ({ applications }) => {
	return (
		<>
			<div className={styles.header}>
				Applications
				<Link to="/app/applications">View All</Link>
			</div>

			<div className={styles.container}>
				{
					applications.length > 0
						? (applications.map((app) => (<AppItem key={app.id} app={app}/>)))
						: (
							<EmptyContent message="No applications available" />
						)
				}
			</div>
		</>
	);
}
